<template>
  <head>
    <meta charset="utf-8" />
    <title>NTSA | Keep Our Roads Safe</title>
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <meta content="Keep your finances and membership up to date" name="description" />
    <meta content="" name="author" />
    <!-- App favicon -->
    <link rel="shortcut icon" href="assets/images/favicon.svg">
    <!-- Bootstrap and other CSS -->
    <link href="assets/libs/bootstrap-datepicker/css/bootstrap-datepicker.min.css" rel="stylesheet" type="text/css">
    <link href="assets/libs/dropzone/min/dropzone.min.css" rel="stylesheet" type="text/css" />
    <link href="assets/libs/datatables.net-bs4/css/dataTables.bootstrap4.min.css" rel="stylesheet" type="text/css" />
    <link href="assets/libs/datatables.net-buttons-bs4/css/buttons.bootstrap4.min.css" rel="stylesheet" type="text/css" />
    <link href="assets/css/bootstrap.min.css" id="bootstrap-style" rel="stylesheet" type="text/css" />
    <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap-select@1.13.14/dist/css/bootstrap-select.min.css">
    <link href="assets/css/icons.min.css" rel="stylesheet" type="text/css" />
    <link href="assets/css/app.min.css" id="app-style" rel="stylesheet" type="text/css" />
    <link href="assets/css/custom.css" id="app-style" rel="stylesheet" type="text/css" />
  </head>

  <body data-sidebar="dark">
  <!-- Begin page -->
  <div id="layout-wrapper">
    <NavigationBar/>

    <div class="content-minimize">
      <div class="page-content">
        <div class="container-fluid">
          <!-- start page title -->
          <div class="row mb-4">
            <div class="col-12">
              <div class="page-title-box d-flex align-items-center justify-content-between">
                <h4 class="mb-0 font-size-18">County Biller Auto Reconciliation</h4>
                <div class="page-title-right">
                  <ol class="breadcrumb m-0">
                    <li class="breadcrumb-item"><a href="javascript: void(0);">Dashboard</a></li>
                    <li class="breadcrumb-item active">Auto Reconciliation</li>
                  </ol>
                </div>
              </div>
            </div>
          </div>
          <!-- end page title -->

          <!-- Quick Stats Row -->
          <div class="row mb-4">
            <div class="col-md-3">
              <div class="card mini-stats-wid">
                <div class="card-body">
                  <div class="d-flex">
                    <div class="flex-grow-1">
                      <p class="text-muted fw-medium mb-2">Total Reconciliations</p>
                      <h4 class="mb-0">{{ uploads.length }}</h4>
                    </div>
                    <div class="mini-stat-icon avatar-sm align-self-center rounded-circle bg-primary">
                        <span class="avatar-title">
                          <i class="bx bx-check-circle font-size-24"></i>
                        </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-3">
              <div class="card mini-stats-wid">
                <div class="card-body">
                  <div class="d-flex">
                    <div class="flex-grow-1">
                      <p class="text-muted fw-medium mb-2">Last Reconciliation</p>
                      <h4 class="mb-0" v-if="uploads.length > 0">{{ formatShortDate(uploads[0].dateCreated) }}</h4>
                      <h4 class="mb-0" v-else>None</h4>
                    </div>
                    <div class="mini-stat-icon avatar-sm align-self-center rounded-circle bg-info">
                        <span class="avatar-title">
                          <i class="bx bx-calendar font-size-24"></i>
                        </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-3">
              <div class="card mini-stats-wid">
                <div class="card-body">
                  <div class="d-flex">
                    <div class="flex-grow-1">
                      <p class="text-muted fw-medium mb-2">Missing Transactions</p>
                      <h4 class="mb-0" v-if="uploads.length > 0">{{ getTotalMissingTransactions() }}</h4>
                      <h4 class="mb-0" v-else>0</h4>
                    </div>
                    <div class="mini-stat-icon avatar-sm align-self-center rounded-circle bg-warning">
                        <span class="avatar-title">
                          <i class="bx bx-error-circle font-size-24"></i>
                        </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-3">
              <div class="card mini-stats-wid">
                <div class="card-body">
                  <div class="d-flex">
                    <div class="flex-grow-1">
                      <p class="text-muted fw-medium mb-2">Amount Reconciled</p>
                      <h4 class="mb-0" v-if="uploads.length > 0">KES {{ formatPrice(getTotalAmount()) }}</h4>
                      <h4 class="mb-0" v-else>KES 0.00</h4>
                    </div>
                    <div class="mini-stat-icon avatar-sm align-self-center rounded-circle bg-success">
                        <span class="avatar-title">
                          <i class="bx bx-money font-size-24"></i>
                        </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Main Card -->
          <div class="row">
            <div class="col-12">
              <div class="card">
                <div class="card-header d-flex justify-content-between align-items-center bg-white border-bottom">
                  <div>
                    <h4 class="card-title m-0">Reconciliation History</h4>
                    <p class="text-muted mb-0 mt-1">View and manage all auto reconciliation entries</p>
                  </div>
                  <div class="d-flex gap-2">
                    <!-- Filter button -->
                    <div class="dropdown d-inline-block me-2">
                      <button type="button" class="btn btn-light" id="page-header-user-dropdown"
                              data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        <i class="mdi mdi-filter-outline align-middle me-1"></i> Filter
                        <i class="mdi mdi-chevron-down d-none d-xl-inline-block"></i>
                      </button>
                      <div class="dropdown-menu dropdown-menu-end" style="min-width: 250px;">
                        <div class="p-3">
                          <h6 class="mb-3">Filter Options</h6>

                          <div class="mb-3">
                            <label class="form-label">Date Range</label>
                            <input type="text" class="form-control" placeholder="Select date range">
                          </div>

                          <div class="mb-3">
                            <label class="form-label">Transaction Type</label>
                            <select class="form-select">
                              <option value="">All Types</option>
                              <option value="MPESA">MPESA</option>
                              <option value="BANK">BANK</option>
                            </select>
                          </div>

                          <div class="d-grid gap-2">
                            <button type="button" class="btn btn-primary">Apply Filter</button>
                            <button type="button" class="btn btn-light">Reset</button>
                          </div>
                        </div>
                      </div>
                    </div>

                    <!-- Export button -->
                    <!-- Replace the current export dropdown with this updated version -->
                    <div class="dropdown d-inline-block me-2" v-if="getRight('DOWNLOAD RECON REPORT')">
                      <button type="button" class="btn btn-light" id="export-dropdown"
                              data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        <i class="mdi mdi-download align-middle me-1"></i> Export
                        <i class="mdi mdi-chevron-down d-none d-xl-inline-block"></i>
                      </button>
                      <div class="dropdown-menu dropdown-menu-end" >
                        <a class="dropdown-item" href="javascript: void(0);" @click.prevent="exportData('excel')">
                          <i class="mdi mdi-file-excel me-1"></i> Excel
                        </a>
                        <a class="dropdown-item" href="javascript: void(0);" @click.prevent="exportData('pdf')">
                          <i class="mdi mdi-file-pdf me-1"></i> PDF
                        </a>
                        <a class="dropdown-item" href="javascript: void(0);" @click.prevent="exportData('csv')">
                          <i class="mdi mdi-file-csv me-1"></i> CSV
                        </a>
                      </div>
                    </div>

                    <!-- Upload button -->
                    <button v-if="getRight('UPLOAD STATEMENT')" class="btn btn-primary" data-bs-toggle="modal" data-bs-target="#uploadFile">
                      <i class="mdi mdi-file-upload-outline align-middle me-1"></i> Upload Statement
                    </button>
                  </div>
                </div>

                <div class="card-body">
                  <!-- Search bar -->
                  <div class="row mb-3">
                    <div class="col-md-6 col-sm-12">
                      <div class="search-box">
                        <div class="position-relative">
                          <input type="text" class="form-control rounded bg-light border-0" placeholder="Search reconciliations...">
                          <i class="mdi mdi-magnify search-icon"></i>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Table with improved design -->
                  <div class="table-responsive">
                    <table class="table table-centered table-hover dt-responsive nowrap w-100" id="recon-datatable">
                      <thead>
                      <tr class="table-light">
                        <th scope="col">Reconciled On</th>
                        <th scope="col">Date Range</th>
                        <th>Type</th>
                        <th>Transactions Status</th>
                        <th>Uploaded By</th>
                        <th>Amount Reconciled</th>
                        <th class="text-center">Actions</th>
                      </tr>
                      </thead>

                      <tbody>
                      <tr :key="index" v-for="(item, index) in uploads">
                        <td>
                          <div class="d-flex flex-column">
                            <span class="fw-medium">{{ formatDate(item.dateCreated) }}</span>
                            <small class="text-muted">{{ formatTime(item.dateCreated) }}</small>
                          </div>
                        </td>
                        <td>
                          <div class="d-flex flex-column">
                            <span class="fw-medium">{{ item.fromDate }} - {{ item.toDate }}</span>
                            <small class="text-muted">{{ calculateDateDifference(item.fromDate, item.toDate) }}</small>
                          </div>
                        </td>
                        <td>
                              <span class="badge" :class="getTransactionTypeClass(item.transactionType)">
                                {{ item.transactionType }}
                              </span>
                        </td>
                        <td>
                          <div class="d-flex align-items-center gap-2">
                            <div class="progress flex-grow-1" style="height: 6px;">
                              <div class="progress-bar" :class="getProgressBarClass(item)" role="progressbar"
                                   :style="{ width: getProgressPercentage(item) + '%' }"
                                   :aria-valuenow="getProgressPercentage(item)" aria-valuemin="0" aria-valuemax="100">
                              </div>
                            </div>
                            <span class="text-nowrap text-muted small">
                                  <span class="fw-bold">{{ item.missingTransactions }}</span> of {{ item.totalRecords }}
                                </span>
                          </div>
                        </td>
                        <td>
                          <div class="d-flex align-items-center gap-2">
                            <div class="avatar-xs">
                                  <span class="avatar-title rounded-circle bg-light text-primary">
                                    {{ getInitials(item.createdBy) }}
                                  </span>
                            </div>
                            <span>{{ item.createdBy }}</span>
                          </div>
                        </td>
                        <td>
                          <div class="d-flex flex-column">
                            <span class="fw-medium">KES {{ formatPrice(item.missingTransactionsAmount) }}</span>
                            <small class="text-muted">of {{ formatPrice(item.totalAmount) }}</small>
                          </div>
                        </td>
                        <td class="text-center">
                          <div class="dropdown">
                            <a class="btn btn-sm btn-icon btn-light" href="javascript: void(0);" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                              <i class="mdi mdi-dots-vertical"></i>
                            </a>
                            <ul class="dropdown-menu dropdown-menu-end">
                              <li><a class="dropdown-item" href="javascript: void(0);" @click="gotTo('recon-details',item.reconCode)">
                                <i class="mdi mdi-eye-outline me-2"></i>View Details
                              </a></li>
                              <li>
                                <a class="dropdown-item" href="javascript: void(0);"
                                   @click="downloadOriginalFile(item.file)"
                                   data-bs-toggle="tooltip"
                                   data-bs-placement="left"
                                   title="Download the original statement file">
                                  <i class="mdi mdi-file-download-outline me-2"></i>Download Original File
                                </a>

                              </li>

                              <li><a class="dropdown-item d-none" href="javascript: void(0);">
                                <i class="mdi mdi-file-download-outline me-2"></i>Download Report
                              </a></li>
                              <li><hr class="dropdown-divider d-none"></li>
                              <li><a class="dropdown-item text-danger" href="javascript: void(0);">
                                <i class="mdi mdi-archive-outline me-2"></i>Archive
                              </a></li>
                            </ul>
                          </div>
                        </td>
                      </tr>
                      </tbody>
                    </table>

                    <!-- Pagination -->
                    <div class="row mt-4">
                      <div class="col-sm-6">
                        <div>
                          <p class="mb-sm-0">Showing <span class="fw-bold">1</span> to <span class="fw-bold">{{ Math.min(uploads.length, 10) }}</span> of <span class="fw-bold">{{ uploads.length }}</span> entries</p>
                        </div>
                      </div>
                      <div class="col-sm-6">
                        <div class="float-sm-end">
                          <ul class="pagination pagination-rounded mb-sm-0">
                            <li class="page-item disabled">
                              <a href="javascript: void(0);" class="page-link"><i class="mdi mdi-chevron-left"></i></a>
                            </li>
                            <li class="page-item active">
                              <a href="javascript: void(0);" class="page-link">1</a>
                            </li>
                            <li class="page-item" v-if="uploads.length > 10">
                              <a href="javascript: void(0);" class="page-link">2</a>
                            </li>
                            <li class="page-item" v-if="uploads.length > 20">
                              <a href="javascript: void(0);" class="page-link">3</a>
                            </li>
                            <li class="page-item" v-if="uploads.length > 30">
                              <a href="javascript: void(0);" class="page-link">...</a>
                            </li>
                            <li class="page-item" v-if="uploads.length > 10">
                              <a href="javascript: void(0);" class="page-link"><i class="mdi mdi-chevron-right"></i></a>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>

                    <!-- Loading state -->
                    <div v-if="loading" class="text-center py-5">
                      <div class="spinner-border text-primary m-2" role="status">
                        <span class="visually-hidden">Loading...</span>
                      </div>
                      <h5 class="mt-2">Loading Reconciliation Data</h5>
                      <p class="text-muted col-md-6 mx-auto">Please wait while we fetch your reconciliation data. This should only take a moment.</p>
                    </div>

                    <!-- No results state -->
                    <div v-if="uploads.length < 1 && !loading" class="text-center py-5">
                      <img src="/assets/images/no-results.png" class="img-fluid mb-4" style="max-height: 150px;" alt="No search results"/>
                      <h4>No Reconciliation Data Available</h4>
                      <p class="text-muted col-md-6 mx-auto">You haven't uploaded any statements for reconciliation yet. Click the "Upload Statement" button to get started.</p>
                      <button v-if="getRight('UPLOAD STATEMENT')" class="btn btn-primary mt-2" data-bs-toggle="modal" data-bs-target="#uploadFile">
                        <i class="mdi mdi-file-upload-outline align-middle me-1"></i> Upload Your First Statement
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- end col -->
          </div>
        </div>
        <!-- container-fluid -->
      </div>
      <!-- End Page-content -->

      <!-- Use the FileUploadPreview component with improved styling -->
      <FileUploadPreview
          @upload-complete="getUploadedTransactions"
          @refresh-uploads="getUploadedTransactions"
      />

      <!-- Footer -->
      <footer class="footer">
        <div class="container-fluid">
          <div class="row">
            <div class="col-sm-6">

            </div>
            <div class="col-sm-6">
              <div class="text-sm-end d-none d-sm-block">
                Keep Our Roads Safe
              </div>
            </div>
          </div>
        </div>
      </footer>
    </div>
    <!-- end main content-->
  </div>
  <!-- END layout-wrapper -->
  </body>
</template>

<script>
/* eslint-disable */
import NavigationBar from "@/components/Navigation";
import {paysol, execute, execute2, biller, getRight, base} from "@/api";
import moment from "moment/moment";
import FileUploadPreview from '@/components/recon/UploadWithPreview.vue';

export default {
  name: "AutoReconciliation",
  components: {
    NavigationBar,
    FileUploadPreview
  },
  data() {
    return {
      exportLoading: false,
      exportType: '',
      showExportToast: false,
      exportMessage: '',
      exportSuccess: true,

      formatType: '',
      bankType: '',
      bankID: '',
      recon: true,
      dateTo: '',
      dateFrom: '',
      statement: '',
      message: null,
      loading: false,
      selectedFile: null,
      alert: {
        success: false,
        info: false,
        failed: false
      },
      uploads: [
        {
          id: null,
          reconCode: null,
          shortCode: null,
          fromDate: null,
          toDate: null,
          totalRecords: null,
          missingTransactions: null,
          file: "/",
          dateCreated: null,
          transactionType: null,
          missingTransactionsAmount: null,
          totalAmount: null,
          createdBy: null
        }
      ],
      banks: [
        {
          id: null,
          bankID: null,
          bank: null,
          payBill: null,
          format: null
        }],
    };
  },
  mounted() {
    this.uploads.splice(0);
    this.getUploadedTransactions();
    this.menuAccess();
    this.getBanks();
  },
  methods: {
    getFileUrl(file){
      return `${base}/biller/uploads/statements/${file}`
    },
    getRight,
    menuAccess() {
      const data = new FormData();
      data.append("function", "menuAccess");
      data.append("menu", "Recon");
      data.append("sessionNames", sessionStorage.getItem("sessionNames"));
      data.append("sessionIdNo", sessionStorage.getItem("sessionIdNo"));
      execute(data, biller)
          .then((res) => {
            // Handle response if needed
          })
          .catch((e) => {
            // Handle error if needed
          });
    },
    formatDateTime(dateTimeStr) {
      const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
      const date = new Date(dateTimeStr);

      if (isNaN(date.getTime())) {
        return 'Invalid Date';
      }

      const day = date.getDate();
      const month = months[date.getMonth()];
      const year = date.getFullYear();
      let hours = date.getHours();
      const minutes = date.getMinutes();
      const period = hours >= 12 ? 'PM' : 'AM';

      hours = hours % 12;
      hours = hours ? hours : 12; // Handle midnight (00:00) as 12 AM

      const formattedDateTime = `${day} ${month} ${year} At ${hours}:${minutes.toString().padStart(2, '0')} ${period}`;
      return formattedDateTime;
    },
    // New formatting methods for improved display
    formatDate(dateTimeStr) {
      if (!dateTimeStr) return 'N/A';
      const date = new Date(dateTimeStr);
      return date.toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' });
    },
    formatTime(dateTimeStr) {
      if (!dateTimeStr) return '';
      const date = new Date(dateTimeStr);
      return date.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit', hour12: true });
    },
    formatShortDate(dateTimeStr) {
      if (!dateTimeStr || this.uploads.length === 0) return 'N/A';
      const date = new Date(dateTimeStr);
      return date.toLocaleDateString('en-GB', { day: 'numeric', month: 'short' });
    },
    calculateDateDifference(fromDate, toDate) {
      if (!fromDate || !toDate) return '';
      const date1 = moment(fromDate, 'DD/MM/YYYY');
      const date2 = moment(toDate, 'DD/MM/YYYY');
      const diffDays = date2.diff(date1, 'days') + 1;
      return `${diffDays} day${diffDays !== 1 ? 's' : ''}`;
    },
    getTransactionTypeClass(type) {
      switch(type?.toUpperCase()) {
        case 'MPESA': return 'bg-success';
        case 'BANK': return 'bg-info';
        default: return 'bg-secondary';
      }
    },
    getProgressPercentage(item) {
      if (!item.totalRecords || item.totalRecords === 0) return 0;
      return Math.round((item.missingTransactions / item.totalRecords) * 100);
    },
    getProgressBarClass(item) {
      const percentage = this.getProgressPercentage(item);
      if (percentage < 30) return 'bg-success';
      if (percentage < 70) return 'bg-warning';
      return 'bg-danger';
    },
    getInitials(name) {
      if (!name) return 'U';
      return name.split(' ').map(n => n[0]).join('').toUpperCase();
    },
    getTotalMissingTransactions() {
      return this.uploads.reduce((total, item) => total + (parseInt(item.missingTransactions) || 0), 0);
    },
    getTotalAmount() {
      return this.uploads.reduce((total, item) => total + (parseFloat(item.missingTransactionsAmount) || 0), 0);
    },
    showDate() {
      const dateObj = new Date();
      const currentDate =
          dateObj.getDate() +
          "/" +
          dateObj.getMonth() +
          "/" +
          dateObj.getFullYear();
      return currentDate;
    },
    formatPrice(value) {
      if (!value) return '0.00';
      let val = (value / 1).toFixed(2).replace(".", ",");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    getUploadedTransactions() {
      this.loading = true;
      const data = new FormData();
      data.append("function", "getUploads");

      execute2(data, paysol)
          .then((res) => {
            if (res.data.success) {
              this.loading = false;
              this.uploads = res.data.data.uploads;
            } else {
              this.loading = false;
            }
          })
          .catch((e) => {
            this.loading = false;
            console.error("Error fetching uploads:", e);
          });
    },
    getBanks() {
      const data = new FormData();
      data.append("function", "getBanks");

      execute(data, biller)
          .then((res) => {
            if (res.data.success) {
              this.banks.splice(0);
              this.banks = res.data.data.banks;
            } else {
              console.error("Failed to fetch banks:", res.data.message);
            }
          })
          .catch((e) => {
            console.error("Error fetching banks:", e);
          });
    },
    getFileName(filePath) {
      const parts = filePath.split('/');
      return parts[parts.length - 1];
    },
    gotTo(route, reconCode) {
      sessionStorage.setItem("reconCode", reconCode);
      this.$router.push(route);
    },
    formattedTime(time) {
      return moment(time).format('hh:mm A');
    },

    // Add these methods to your Vue component's methods section

// Main export handler to choose the right export format
    exportData(type) {
      switch(type) {
        case 'excel':
          this.exportToExcel();
          break;
        case 'pdf':
          this.exportToPDF();
          break;
        case 'csv':
          this.exportToCSV();
          break;
        default:
          console.error('Unknown export type:', type);
      }
    },

// Export to CSV
    exportToCSV() {
      // Define the CSV header
      const header = [
        'Reconciled On',
        'Date Range',
        'Type',
        'Missing Transactions',
        'Total Records',
        'Uploaded By',
        'Missing Amount',
        'Total Amount'
      ].join(',');

      // Map data to CSV rows
      const rows = this.uploads.map(item => [
        this.formatDate(item.dateCreated) + ' ' + this.formatTime(item.dateCreated),
        item.fromDate + ' - ' + item.toDate,
        item.transactionType || 'N/A',
        item.missingTransactions || '0',
        item.totalRecords || '0',
        item.createdBy || 'Unknown',
        item.missingTransactionsAmount ? 'KES ' + this.formatPrice(item.missingTransactionsAmount) : 'KES 0.00',
        item.totalAmount ? 'KES ' + this.formatPrice(item.totalAmount) : 'KES 0.00'
      ].join(','));

      // Combine header and rows
      const csv = [header, ...rows].join('\n');

      // Create a Blob with the CSV data
      const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });

      // Create a download link
      this.downloadFile(blob, 'reconciliation_export_' + this.getCurrentDate() + '.csv');
    },

// Export to Excel (using CSV approach with .xlsx extension for simplicity)
    exportToExcel() {
      // For a true Excel export, you would typically use a library like SheetJS/xlsx
      // But for a front-end only solution without additional dependencies, we'll create a CSV
      // with Excel extension which Excel can open

      // Define the CSV header
      const header = [
        'Reconciled On',
        'Date Range',
        'Type',
        'Missing Transactions',
        'Total Records',
        'Uploaded By',
        'Missing Amount',
        'Total Amount'
      ].join('\t'); // Using tab delimiter for better Excel compatibility

      // Map data to Excel-friendly rows
      const rows = this.uploads.map(item => [
        this.formatDate(item.dateCreated) + ' ' + this.formatTime(item.dateCreated),
        item.fromDate + ' - ' + item.toDate,
        item.transactionType || 'N/A',
        item.missingTransactions || '0',
        item.totalRecords || '0',
        item.createdBy || 'Unknown',
        item.missingTransactionsAmount ? 'KES ' + this.formatPrice(item.missingTransactionsAmount).replace(',', '.') : 'KES 0.00',
        item.totalAmount ? 'KES ' + this.formatPrice(item.totalAmount).replace(',', '.') : 'KES 0.00'
      ].join('\t'));

      // Combine header and rows
      const excel = [header, ...rows].join('\n');

      // Create a Blob with the data
      const blob = new Blob([excel], { type: 'application/vnd.ms-excel;charset=utf-8;' });

      // Create a download link
      this.downloadFile(blob, 'reconciliation_export_' + this.getCurrentDate() + '.xlsx');
    },

// Export to PDF
    exportToPDF() {
      // For a true PDF export, you would typically use a library like jsPDF
      // Here we'll create a simple HTML-to-PDF approach that works in the browser

      // Create a new window for the PDF
      const printWindow = window.open('', '_blank');

      // Create HTML content for the printable page
      const html = `
    <!DOCTYPE html>
    <html>
    <head>
      <title>Reconciliation Export - ${this.getCurrentDate()}</title>
      <style>
        body { font-family: Arial, sans-serif; margin: 20px; }
        h1 { color: #333; font-size: 24px; margin-bottom: 20px; }
        table { width: 100%; border-collapse: collapse; margin-bottom: 20px; }
        th, td { border: 1px solid #ddd; padding: 8px; text-align: left; }
        th { background-color: #f1f1f1; font-weight: bold; }
        .header { display: flex; justify-content: space-between; margin-bottom: 20px; }
        .logo { font-weight: bold; font-size: 20px; }
        .footer { margin-top: 30px; text-align: center; font-size: 12px; color: #666; }
        @media print {
          .no-print { display: none; }
          body { margin: 0; }
        }
      </style>
    </head>
    <body>
      <div class="header">
        <div class="logo"></div>
        <div>
          <h2>County Biller Auto Reconciliation</h2>
          <p>Generated on ${this.formatDate(new Date())} at ${this.formatTime(new Date())}</p>
        </div>
      </div>

      <h3>Reconciliation Summary</h3>
      <table>
        <tr>
          <th>Total Reconciliations</th>
          <th>Missing Transactions</th>
          <th>Amount Reconciled</th>
        </tr>
        <tr>
          <td>${this.uploads.length}</td>
          <td>${this.getTotalMissingTransactions()}</td>
          <td>KES ${this.formatPrice(this.getTotalAmount())}</td>
        </tr>
      </table>

      <h3>Reconciliation Details</h3>
      <table>
        <tr>
          <th>Reconciled On</th>
          <th>Date Range</th>
          <th>Type</th>
          <th>Missing / Total</th>
          <th>Uploaded By</th>
          <th>Amount (KES)</th>
        </tr>
        ${this.uploads.map(item => `
          <tr>
            <td>${this.formatDate(item.dateCreated)} ${this.formatTime(item.dateCreated)}</td>
            <td>${item.fromDate} - ${item.toDate}</td>
            <td>${item.transactionType || 'N/A'}</td>
            <td>${item.missingTransactions || '0'} / ${item.totalRecords || '0'}</td>
            <td>${item.createdBy || 'Unknown'}</td>
            <td>${this.formatPrice(item.missingTransactionsAmount || 0)} / ${this.formatPrice(item.totalAmount || 0)}</td>
          </tr>
        `).join('')}
      </table>

      <div class="footer">
        <p>NTSA County Biller Auto Reconciliation Report - Confidential</p>
        <p>Keep Our Roads Safe</p>
      </div>

      <div class="no-print" style="text-align: center; margin-top: 20px;">
        <button onclick="window.print()">Print PDF</button>
      </div>
    </body>
    </html>
  `;

      // Write to the new window and prepare for printing
      printWindow.document.open();
      printWindow.document.write(html);
      printWindow.document.close();

      // Add a slight delay before triggering print to ensure content is loaded
      setTimeout(() => {
        printWindow.focus();
        // Let the user print manually with the print button
      }, 500);
    },

// Utility function for file downloads
    downloadFile(blob, filename) {
      // Create a link element
      const link = document.createElement('a');

      // Create a URL for the blob
      const url = URL.createObjectURL(blob);

      // Set link properties
      link.href = url;
      link.download = filename;

      // Append to body, click, and remove
      document.body.appendChild(link);
      link.click();

      // Clean up
      setTimeout(() => {
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
      }, 100);
    },

    // Add to your methods section
    downloadOriginalFile(filename) {
      if (!filename) {
        // Show error toast or alert if file is not available
        this.$bvToast.toast('File not available for download', {
          title: 'Download Error',
          variant: 'danger',
          solid: true
        });
        return;
      }

      // Get the file URL using the existing getFileUrl method
      const fileUrl = this.getFileUrl(filename);

      // Create a temporary anchor element
      const link = document.createElement('a');
      link.href = fileUrl;
      link.target = '_blank';

      // Set the download attribute with a formatted filename
      // Extract original filename from the path if possible
      const originalName = this.getFileName(filename);
      link.download = originalName;

      // Append to the document, click and remove
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },

// Get current date in YYYY-MM-DD format for filenames
    getCurrentDate() {
      const date = new Date();
      return date.toISOString().split('T')[0];
    }
  },
};
</script>

<style scoped>
.table-responsive {
  overflow-x: auto;
}

/* Table styling */
.table th {
  font-weight: 600;
  font-size: 0.875rem;
}

.table td {
  vertical-align: middle;
  padding: 0.75rem;
}

/* Card styling */
.card {
  border-radius: 0.5rem;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);
}

.card-header {
  padding: 1rem 1.5rem;
}

/* Badge styling */
.badge {
  font-weight: 500;
  padding: 0.35em 0.65em;
  font-size: 0.75em;
  border-radius: 0.25rem;
}

/* Search box styling */
.search-box {
  position: relative;
  max-width: 400px;
}

.search-box .form-control {
  padding-left: 40px;
  height: 38px;
}

.search-box .search-icon {
  position: absolute;
  left: 13px;
  top: 10px;
  font-size: 18px;
  color: #74788d;
}

/* Mini stats card */
.mini-stats-wid .mini-stat-icon {
  overflow: hidden;
  position: relative;
}

.mini-stats-wid .avatar-sm {
  height: 3rem;
  width: 3rem;
}

.avatar-xs {
  height: 2rem;
  width: 2rem;
}

.rounded-circle {
  border-radius: 50% !important;
}

.avatar-title {
  align-items: center;
  display: flex;
  font-weight: 500;
  height: 100%;
  justify-content: center;
  width: 100%;
}

/* Make modals responsive */
@media (min-width: 992px) {
  .modal-lg {
    max-width: 800px;
  }
}

@media (max-width: 767.98px) {
  .page-title-box {
    padding-bottom: 15px;
  }

  .card-header {
    flex-direction: column;
    align-items: flex-start !important;
  }

  .card-header > div:last-child {
    margin-top: 1rem;
    width: 100%;
  }

  .card-header > div:last-child .btn {
    width: 100%;
  }
}
</style>